import * as React from 'react';
import { FormattedMessage } from 'react-intl';

import { useShortNumber, THOUSAND } from '@xing-com/crate-social-utils';
import { scale090 } from '@xing-com/tokens';

import { Styled } from './share-counter.style';

export type ShareCounterProps = {
  compact?: boolean;
  counter: number;
};

export const ShareCounter: React.FC<ShareCounterProps> = ({
  counter,
  compact = false,
}) => {
  const { shortNumber } = useShortNumber(counter);

  return (
    // @ts-expect-error FIXME: SC6
    <Styled.ShareCounter
      data-testid="share-counter"
      fontWeight="regular"
      size="small"
      noMargin
    >
      {compact ? (
        <React.Fragment>
          <Styled.ShareIcon height={scale090} width={scale090} />
          {shortNumber}
        </React.Fragment>
      ) : counter < THOUSAND ? (
        <FormattedMessage id="SHARE_COUNTER_LABEL" values={{ counter }} />
      ) : (
        <FormattedMessage
          id="SOCIAL_SHARE_COUNTER_LABEL"
          values={{ amount: shortNumber }}
        />
      )}
    </Styled.ShareCounter>
  );
};
